module.exports = __webpack_public_path__ + "img/chl.455b3612.svg";